import {  Content, ContentCardWrapper, Title, TitleCn } from "./MovingMotorContentCard.styled";
import { CSSProperties } from "styled-components";

interface MovingMotorContentCardProps {
    titleCn: string,
    data:string,
    style?: CSSProperties,
    titlestyle?: CSSProperties,
    datastyle?: CSSProperties,
}

let MovingMotorContentCard: React.FC<MovingMotorContentCardProps> = (props)=> {

    return <ContentCardWrapper style={props.style}>
        <Title style={props.titlestyle}>
            <TitleCn>{props.titleCn}</TitleCn>
        </Title>
        <Content style={props.datastyle}>
            转速{props.data}
        </Content>
        



        
    </ContentCardWrapper>
};

export default MovingMotorContentCard;

